import React from 'react';
import styled from 'styled-components';
import { theme } from '../../../theme/semanticTokens';
import { Typography } from '../../../Typography';

export interface InputClearActionProps {
  className?: string;
  onClear?: () => void;
  label?: string;
}

const ClearRow = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

const ClearButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
`;

const ClearLabel = styled(Typography)`
  color: ${theme.dime.colors.link.primary};
`;

export const InputClearAction: React.FC<InputClearActionProps> = ({
  className,
  onClear,
  label = 'Clear'
}) => (
  <ClearRow className={className}>
    <ClearButton type="button" onClick={() => onClear?.()}>
      <ClearLabel variant="body1">{label}</ClearLabel>
    </ClearButton>
  </ClearRow>
);
